"use strict";
import Lottie from "lottie-react";
import { Hero } from "pages/Landing/sections/Hero";
import { memo, useMemo } from "react";
import { Flex, styled, useMedia } from "ui/src";
import { INTERFACE_NAV_HEIGHT } from "ui/src/theme";
import mobHeroLottie from "../../assets/lotties/mob-hero.json";
import pcHeroLottie from "../../assets/lotties/pc-hero.json";
const LottieWrapper = styled(Flex, {
  position: "absolute",
  top: 100,
  left: 50,
  width: "100%",
  height: "100vh",
  pointerEvents: "none",
  zIndex: 1,
  overflow: "hidden"
});
function LandingV2() {
  const media = useMedia();
  const lottieData = useMemo(() => media.sm ? mobHeroLottie : pcHeroLottie, [media.sm]);
  return <Flex
    position="relative"
    alignItems="center"
    mt={-INTERFACE_NAV_HEIGHT}
    minWidth="100vw"
    data-testid="landing-page"
    $md={{ pb: "$spacing60" }}
    $sm={{ pb: "$spacing60" }}
    mb={100}
  >
      {
    /* Lottie animation background */
  }
      <LottieWrapper position="absolute">
        <Lottie autoplay loop animationData={lottieData} renderer="svg" />
      </LottieWrapper>

      <Hero />
    </Flex>;
}
export default memo(LandingV2);
